import {EmbedCodeExtractor} from "./types"

/**
 * Twitter/X embed-code extractor (resolve-long-embed-codes, design D3 symmetry). Sample:
 *
 *   <blockquote class="twitter-tweet"><p lang="en" dir="ltr">text…</p>&mdash; User (@user)
 *     <a href="https://twitter.com/user/status/123456789?ref_src=twsrc%5Etfw">Date</a>
 *   </blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
 *
 * Gated on the `twitter-tweet` blockquote class so bare status URLs return null (they
 * are matched by the Twitter provider directly). The captured URL stops at the status
 * id, dropping tracking query params, and is matched by the Twitter provider pattern
 * (providers/twitter.ts). Server-side this is behavior-neutral: the provider pattern
 * already extracted the same URL out of the raw blockquote.
 */
const TWITTER_EMBED_MARKER = /class=["']twitter-tweet["']/i

const TWITTER_BLOCKQUOTE_TAG = /<blockquote\b[^>]*class=["']twitter-tweet["'][^>]*>/i

const STATUS_URL_PATTERN = /href=["'](https?:\/\/(?:www\.|mobile\.)?(?:twitter|x)\.com\/\w+\/status(?:es)?\/\d+)[^"']*["']/i

export const twitterPreProcessor: EmbedCodeExtractor = (input: string) => {
  if(!TWITTER_EMBED_MARKER.test(input)) return null
  // The permalink is searched within the twitter-tweet blockquote only — an unrelated
  // status link elsewhere in the paste must not win (Copilot finding on PR #789; same
  // scoping as the TikTok extractor). Note the end-to-end result for a blockquote
  // without a permalink is unchanged: the extractor falls through and the server's
  // provider regex scans the raw input as it always did.
  const tag = TWITTER_BLOCKQUOTE_TAG.exec(input)
  if(tag === null) return null
  const bodyStart = tag.index + tag[0].length
  const bodyEnd = input.indexOf("</blockquote>", bodyStart)
  const body = bodyEnd === -1 ? input.slice(bodyStart) : input.slice(bodyStart, bodyEnd)
  const match = STATUS_URL_PATTERN.exec(body)
  return match ? match[1] : null
}
